import { Questao } from './../../models/questao.model';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestaoService {

  baseUrlSite = environment.baseUrlSite;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  public read(): Observable<Questao[]> {
    const service = 'questoes';
    return this.http.get<Questao[]>(this.baseUrlSite + service);
  }

  public contaQuestoesPorQuestionario(id: any): Observable<any> {
    const service = `${'questoes/questionario'}/${id}`;
    return this.http.get<any>(this.baseUrlSite + service);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
